export type ModalTrayTone = 'neutral' | 'warning' | 'error' | 'success';

export const MODAL_TRAY_CAPTION_COLOR: Record<ModalTrayTone, string> = {
    neutral: 'var(--malachite-text-secondary)',
    warning: 'var(--malachite-tag-warning-foreground)',
    error: 'var(--malachite-tag-error-foreground)',
    success: 'var(--malachite-tag-success-foreground)',
};

export const MODAL_TRAY_BACKGROUND: Record<ModalTrayTone, string> = {
    neutral: 'var(--malachite-card-tray-neutral, var(--malachite-card-dimmed-background))',
    warning:
        'var(--malachite-card-tray-warning, var(--malachite-table-row-variant-warning-background))',
    error: 'var(--malachite-card-tray-error, var(--malachite-table-row-variant-error-background))',
    success:
        'var(--malachite-card-tray-success, var(--malachite-table-row-variant-success-background))',
};
